import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=54a727cb&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=54a727cb&scoped=true&lang=css&"
import style1 from "./NotificationsBell.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a727cb",
  null
  
)

export default component.exports